export default __webpack_public_path__ + "Geist-Variable.woff2";